module.exports = __webpack_public_path__ + "static/media/Task.871d542c.png";